/* src/app/modules/employees/turnos/calendario.component.scss */
.empleado-color {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}
.empleado-color-vacaciones {
  width: 20px;
  height: 20px;
  border-radius: 0;
  margin-right: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.empleado-color-baja {
  width: 20px;
  height: 20px;
  border-radius: 0;
  margin-right: 8px;
  border: 1px solid rgba(255, 0, 0, 0.1);
}
.empleado-color-asuntos-propios {
  width: 20px;
  height: 20px;
  border-radius: 0;
  margin-right: 8px;
  border: 1px solid rgba(0, 255, 0, 0.1);
}
.empleados-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
  margin-top: 1rem;
}
.empleado-item {
  padding: 8px;
  border-radius: 4px;
  background-color: #f5f5f5;
}
.empleado-vacaciones,
.empleado-baja,
.empleado-asuntos-propios {
  border-radius: 0;
}
.texto-vacaciones {
  font-style: italic;
  color: #777;
}
.texto-baja {
  color: #000000;
}
.texto-asuntos-propios {
  color: #000000;
}
.navegacion-mes {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}
.navegacion-mes button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
}
.navegacion-mes mat-icon {
  margin: 0 4px;
}
.cal-cell-top {
  min-height: 30px;
}
.cal-event {
  width: 10px !important;
  height: 10px !important;
  margin: 1px !important;
  display: inline-block !important;
  cursor: pointer;
}
.cal-event.evento-vacaciones {
  border-radius: 0 !important;
}
.cal-day-view .cal-event.evento-vacaciones .cal-event-title {
  font-style: italic;
}
.evento-indicador {
  width: 10px !important;
  height: 10px !important;
  margin: 1px !important;
  display: inline-block !important;
}
.evento-indicador.evento-vacaciones {
  border-radius: 0 !important;
}
.evento-vacaciones {
  width: 10px !important;
  height: 10px !important;
  margin: 1px !important;
  display: inline-block !important;
  border: 1px solid rgba(0, 0, 0, 0.5);
}
.evento-baja {
  width: 10px !important;
  height: 10px !important;
  margin: 1px !important;
  display: inline-block !important;
  border: 1px solid rgba(255, 0, 0, 0.5);
  background-color: #ff0000 !important;
}
.evento-asuntos-propios {
  width: 10px !important;
  height: 10px !important;
  margin: 1px !important;
  display: inline-block !important;
  border: 1px solid rgba(0, 255, 0, 0.5);
  background-color: #00ff00 !important;
}
::ng-deep .evento-vacaciones {
  border-radius: 0 !important;
}
::ng-deep .evento-vacaciones > span.cal-event {
  background-color: #fff !important;
  border-radius: 0 !important;
}
::ng-deep .evento-baja {
  border-radius: 0 !important;
}
::ng-deep .evento-baja > span.cal-event {
  background-color: #ff0000 !important;
  border-radius: 0 !important;
}
::ng-deep .evento-asuntos-propios {
  border-radius: 0 !important;
}
::ng-deep .evento-asuntos-propios > span.cal-event {
  background-color: #00ff00 !important;
  border-radius: 0 !important;
}
.evento-color {
  display: inline-block;
}
::ng-deep .mat-mdc-tooltip {
  background-color: rgba(97, 97, 97, 0.9);
  font-size: 14px !important;
  padding: 8px 10px !important;
  max-width: 250px !important;
  white-space: normal !important;
  word-break: break-word !important;
  line-height: 1.5 !important;
  border-radius: 4px !important;
}
/*# sourceMappingURL=calendario.component.css.map */
